import { Link } from "react-router-dom";
import { displayDate } from "../../../../utils/dateHandler.util";
import ProcessWithdrawalRequest from "./processWithdrawalRequest";
import { WithdrawalRequest } from "../../types/withdrawal-request.entity";
import { useTheme } from "src/context/theme.context";

interface Props {
  withdrawalRequests: WithdrawalRequest[];
}

const WithdrawalTable: React.FC<Props> = ({ withdrawalRequests }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="overflow-x-auto mb-6">
      <table
        className={`min-w-full border divide-y ${
          isDarkMode ? "border-gray-700 divide-gray-700 bg-gray-900 text-gray-100" : "border-gray-200 divide-gray-200 bg-white text-gray-900"
        }`}
      >
        <thead className="bg-gray-800 text-white text-center">
          <tr>
            <th className="px-4 py-3">User Name</th>
            <th className="px-4 py-3">User Email</th>
            <th className="px-4 py-3">User Role</th>
            <th className="px-4 py-3">Account Type</th>
            <th className="px-4 py-3">Amount</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Date</th>
            <th className="px-4 py-3">Action</th>
          </tr>
        </thead>

        <tbody>
          {withdrawalRequests.length === 0 && (
            <tr>
              <td colSpan={8} className={`text-center py-4 text-xl ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>
                No withdrawal requests
              </td>
            </tr>
          )}

          {withdrawalRequests.map((req) => (
            <tr
              key={req.id}
              className={`text-center transition-colors ${
                isDarkMode
                  ? "odd:bg-gray-900 even:bg-gray-800 hover:bg-gray-700 text-gray-100"
                  : "odd:bg-white even:bg-gray-50 hover:bg-gray-100 text-gray-900"
              }`}
            >
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
                {req.user ? (
                  <Link
                    to={`/users/${req.userId}`}
                    className={`no-underline ${isDarkMode ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-700"}`}
                  >
                    {req.user.name}
                  </Link>
                ) : (
                  "-"
                )}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-300" : "border-gray-200 text-gray-700"}`}>
                {req.user?.email || "-"}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-300" : "border-gray-200 text-gray-700"}`}>
                {req.accountType.toLocaleLowerCase()}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-300" : "border-gray-200 text-gray-700"}`}>
                {req.userRole || "COACH"}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-100" : "border-gray-200 text-gray-900"}`}>
                {req.amount}
                {req.currency === "EUR" ? " EUR" : " $"}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-300" : "border-gray-200 text-gray-700"}`}>
                {req.status}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700 text-gray-300" : "border-gray-200 text-gray-700"}`}>
                {req.createdAt ? displayDate(req.createdAt) : "-"}
              </td>
              <td className={`px-4 py-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
                {req.status === "APPROVED" && req.accountType === "PERSONAL" ? (
                  <Link
                    to={`/withdrawal-requests/${req.id}/invoice`}
                    className={isDarkMode ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-700"}
                  >
                    Invoice
                  </Link>
                ) : req.status === "PENDING" ? (
                  <div className="flex justify-center gap-2">
                    <ProcessWithdrawalRequest
                      withdrawalRequest={req}
                      action="APPROVE"
                      title="Do you accept tutor withdrawal request?"
                      confirmLabel="Accept"
                      buttonVariant="primary"
                    />
                    <ProcessWithdrawalRequest
                      withdrawalRequest={req}
                      action="REJECT"
                      title="Do you reject tutor withdrawal request?"
                      confirmLabel="Reject"
                      buttonVariant="danger"
                    />
                  </div>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WithdrawalTable;
